import { useEffect, useState } from 'react'

import { getFunctionalRoleList } from '../../../api'
import { EMPTY_LIST } from '../../../constants/common'
import { useApi, useNotification } from '../../../hooks'
import { ButtonSelect, SelectDropdownListHeader } from '../../Select'

import { toUserStaffFunctionalRoleSelectOptions } from './UserStaffFunctionalRoleSelect.utils'

function UserStaffFunctionalRoleSelect({
  listProps,
  options = null,
  ...restProps
}) {
  const [loadedOptions, setLoadedOptions] = useState(EMPTY_LIST)

  const api = useApi()

  const { handleAddErrorNotification } = useNotification()

  useEffect(() => {
    if (!options) {
      api
        .call(({ options: apiOptions }) =>
          getFunctionalRoleList({ options: apiOptions })
        )
        .then(response => {
          if (response) {
            setLoadedOptions(
              toUserStaffFunctionalRoleSelectOptions(response.data)
            )
          }
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
    }

    return () => {
      api.abort()
    }
  }, [options])

  return (
    <ButtonSelect
      {...restProps}
      listProps={{
        ...listProps,
        Header: SelectDropdownListHeader,
      }}
      options={options ?? loadedOptions}
    />
  )
}

export default UserStaffFunctionalRoleSelect
